/* eslint-disable @typescript-eslint/no-explicit-any */
import { FieldErrors, FieldValues, Resolver } from 'react-hook-form';
import * as yup from 'yup';

export const createYupValidationResolver = <TFieldValues extends FieldValues>(
  validationSchema: yup.SchemaOf<TFieldValues>,
): Resolver<TFieldValues> => {
  return async (data) => {
    try {
      const values = await validationSchema.validate(data, {
        abortEarly: false,
      });

      return {
        values: values || {},
        errors: {} as FieldErrors<TFieldValues>,
      };
    } catch (errors: any) {
      return {
        values: {},
        errors: errors.inner.reduce(
          (allErrors: any, currentError: any) => ({
            ...allErrors,
            [currentError.path]: {
              type: currentError.type ?? 'validation',
              message: currentError.message,
            },
          }),
          {},
        ),
      };
    }
  };
};
